import React, { useContext, useMemo } from 'react';
import { useStorePage } from '../Store/StorePageContext';
import { StoreContext } from '../StoreHandler/StoreContext';
import { styled } from 'linaria/react';
import { theme } from '../Theme';
import ContactForm from '../ContactForm/ContactForm';
import { Button } from '../ui/Button';
import ModalTrigger from '../ui/ModalTrigger';
import { ReactComponent as CrossSvg } from '../../svg/Cross.svg';
import MaxWidth from '../Layout/MaxWidth';
import t from '@jetshop/intl';

const ShopInformationWrapper = styled.div`
  max-width: 80rem;
  padding: 0 2rem;
  display: flex;
  margin: 0 auto;
  gap: 20px;
  justify-content: space-between;

  ${theme.below.lg} {
    flex-direction: column;
  }
`;

const ShopInformationItem = styled.div`
  flex: 1;
  background-color: #e9e4e0;
  padding: 24px;
  border-radius: 4px;

  a {
    color: #911827;
  }
`;

const ModalContainer = styled(MaxWidth)`
  background: ${theme.colors.white};
  max-width: 100%;
  padding: 1rem 2rem 2rem !important;
  border-radius: 4px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.1);

  & div:nth-child(5) {
    text-align: center;
  }

  ${theme.below.md} {
    margin: 0;
    width: 100%;
    height: auto;
  }
`;

const CloseIcon = styled('button')`
  outline: none;
  background: #ffffff;
  position: absolute;
  right: 2rem;
  top: 2rem;

  svg {
    height: 14px;
    width: 14px;
    stroke-width: 0.5px;

    path {
      stroke: #111111;
    }
  }
`;

const convertNewlinesToBr = (text) => {
  // should not replace newlines inside tags
  const temp = text.replace(/<[^>]*>/g, (match) => {
    return match.replace(/\n/g, '<br/>');
  });
  return temp;
};

const ContactFormModal = ({ hideTarget, store }) => (
  <ModalContainer>
    <CloseIcon onClick={hideTarget}>
      <CrossSvg />
    </CloseIcon>
    <ContactForm store={store} hideTarget={hideTarget} isModal />
  </ModalContainer>
);

export const ShopInformation = ({
  storeOpeningHours,
  storeManager,
  storeContact,
}) => {
  const { store, storeId } = useStorePage();
  const { storeList } = useContext(StoreContext);

  const currentStore = useMemo(() => {
    return storeList.find(
      (store) =>
        store?.extra?.id === parseInt(storeId) && store?.extra !== undefined
    );
  }, [storeList, storeId]);

  const personelInfo = useMemo(() => {
    if (currentStore?.storeInfo?.['personal-info']?.length > 0) {
      return currentStore?.storeInfo?.['personal-info'];
    }
    if (store?.address2?.length > 0) {
      return store?.address2;
    }
    return null;
  }, [currentStore, store]);

  return (
    <ShopInformationWrapper>
      {storeOpeningHours?.value === true && (
        <ShopInformationItem>
          {currentStore && currentStore?.storeInfo ? (
            <div
              dangerouslySetInnerHTML={{
                __html: convertNewlinesToBr(
                  '<h3>Öppettider</h3>' +
                    currentStore?.storeInfo?.['open-hours']
                ),
              }}
            />
          ) : (
            <div dangerouslySetInnerHTML={{ __html: store.openHours }} />
          )}
        </ShopInformationItem>
      )}

      {storeManager?.value === true && personelInfo && (
        <ShopInformationItem>
          <div
            dangerouslySetInnerHTML={{
              __html: personelInfo.replace(
                '<p><strong>Personal</strong></p>',
                '<h3>Personal</h3>'
              ),
            }}
          />
        </ShopInformationItem>
      )}

      {storeContact?.value === true && (
        <ShopInformationItem>
          {currentStore && currentStore?.storeInfo ? (
            <>
              <h3>Kontakt</h3>
              <p>{currentStore?.storeInfo.address}</p>
              <p>
                {currentStore?.storeInfo.zip} {currentStore?.storeInfo.city}
              </p>
              <p>{currentStore?.storeInfo.phone}</p>
              <p>
                <a href={`mailto:${currentStore?.storeInfo.email}`}>
                  {currentStore?.storeInfo.email}
                </a>
              </p>
              <ModalTrigger
                target={(props) => (
                  <ContactFormModal store={store} {...props} />
                )}
              >
                {({ showTarget }) => (
                  <Button style={{ marginTop: '2rem' }} onClick={showTarget}>
                    {t('Kontaktformulär')}
                  </Button>
                )}
              </ModalTrigger>
            </>
          ) : (
            <>
              <div dangerouslySetInnerHTML={{ __html: store.contact }} />
              <ModalTrigger
                target={(props) => (
                  <ContactFormModal store={store} {...props} />
                )}
              >
                {({ showTarget }) => (
                  <Button style={{ marginTop: '2rem' }} onClick={showTarget}>
                    {t('Kontaktformulär')}
                  </Button>
                )}
              </ModalTrigger>
            </>
          )}
        </ShopInformationItem>
      )}
    </ShopInformationWrapper>
  );
};
